export default __webpack_public_path__ + "static/FrannieL-1f127f4f204b1a32c4f2711d2b8e2a66.png";